<iris-card [elevation]="1">
  <div class="card-contents">
    <h2>Connect with {{ firstName }}</h2>
    <div *ngIf="soonestAvailableDate" class="soonest-available">
      Soonest available session: {{ soonestAvailableDate | date:'EEEE LLLL d' }}
    </div>
    <div class="instructions">
      <p class="questions"> Want to book a session? Have questions? </p>
      <p>You can book a time that's right for you and message with {{ firstName }} after creating your free account.</p>
      <p class="call-to-action">Answer a few simple questions to get started!</p>
    </div>

    <iris-card-footer>  
      <iris-button
        *ngIf="useCheckoutFormFf; else linkToFlow"
        class="request-session-button"
        data-test="request-session-button"
        (click)="onCtaClicked(false)"
      >
        {{ ctaButtonText }}
      </iris-button>
      <ng-template #linkToFlow>
        <a
          [routerLink]="['/match', paramsShareCode, paramsName]"
          [queryParams]="requestSessionQueryParams"
          class="iris-button iris-button--primary"
          data-test="request-session-button"
          tabindex="0"
          (click)="onCtaClicked(true)"
        >
          {{ ctaButtonText }}
        </a>
      </ng-template>
     </iris-card-footer>
  </div>
</iris-card>
